<template>
    <div class="room_card">
        <div class="room_image" :class="{selected}">
            <router-link :to="`/room/${item.photo_id}`">
                <img v-if="item.image_name" :src="`${root_path}room_image/${item.image_name}.jpg`" alt="room_image" @click="setRoom">
                <img v-else :src="item.url" alt="room_image" @click="setRoom">
            </router-link>
        </div>
        <div class="tags">
            <RoomTag v-for="tag in filtered_tags" :tag="tag" :key="tag.id"/>
        </div>
        <div class="favorite">
            <PlanBoardButton :photo_data="item" :list_id="list_id" v-if="plan_board"/>
            <FavoriteButton :photo_data="item"/>
        </div>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'
    import AppPath from '../assets/js/AppPath'
    import FavoriteButton from '../components/FavoriteButton'
    import PlanBoardButton from '../components/PlanBoardButton'
    import RoomTag from '../components/RoomTag'

    export default {
        name: "RoomCard",
        props: {
            item: Object,
            plan_board: Boolean,
            list_id: String
        },
        components: { FavoriteButton, PlanBoardButton, RoomTag },
        data: () => ({
            root_path: AppPath.root,
            selected: false
        }),
        methods: {
            ...mapMutations('search', ["setSelectedRoomInfo"]),
            setRoom() {
                this.setSelectedRoomInfo(this.item);
            },
            timerEvent() {
                console.log('selected room_id: ' + this.item.photo_id);
                this.selected = true;
            }
        },
        computed: {
            //写真一覧では写真下のタグは「スタイル」と「部屋別」のみ表示
            filtered_tags: _this => {
                return _this.item.tags.filter(tag => tag.category === 'style' || tag.category === 'room');
            }
        }
    }
</script>

<style scoped lang="scss">
    .room_card {
        margin-bottom: 30px;
        width: 200px;
        position: relative;
        user-select: none;

        .favorite{
            display: flex;
            position: absolute;
            top: 10px;
            right: 10px;
            > *:not(:last-child) {
                margin-right: 5px;
            }
        }
        .room_image{
            position: relative;
            margin-bottom: 15px;
            &:hover{
                opacity: 0.8;
            }
            img{
                border-radius: 5px;
                width: 100%;
                vertical-align: middle;
            }
            a{
                display: block;
            }
            &.selected:before{
                content: '';
                width: 30px;
                height: 30px;
                background-color: royalblue;
                border-radius: 100%;
                position: absolute;
                top: 10px;
                right: 10px;
            }
        }
        .tags{
            display: flex;
            flex-wrap: wrap;
            .tag{
            }
        }
    }

    @media screen and (max-width:639px) {
        .room_card {
            width: initial;
            margin: 0 8px 30px;
            .room_image {
                margin-bottom: 6px;
            }
        }
    }
</style>
